import React, { createRef, useCallback, useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";
import _ from "lodash";
import RouteModal from "../../sections/route-modal";
import ImageCarouselModal from "../../sections/image-carousel-modal";
import { isArray, isString } from "../../utils/obj-utils";
import { gtag } from "../../utils";
import "./style.scss";

const NewsList = props => {
	const { lang, rendering, fields, page } = props;
  const { list, pageSize, showPage, buttonText, colorScheme, iconName, link, prevButtonText, prevColorScheme, prevIconName, dragtext } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const rootEl = useRef()
  const [currentPage, setCurrentPage] = useState(0)
  const [isActive, setIsActive] = useState(false)
  const modalRef = createRef();
  const [showDrag, setShowDrag] = useState(false)
  const [startX, setStartX] = useState(false)
  const [overButton ,setOverButton] = useState(false)
  const routeModalRef = createRef();
  const dragEl = useRef()
  let pageSizeValue = isMobile ? 3 : pageSize.value
  const debouncedSlideClick = useCallback(_.debounce(callback => callback(), 50));
  const onSlideClick = data => {
    gtag('event', 'Component_info', {
      'component_name': 'NewsList',
      'page_title': page?.name
    });
    debouncedSlideClick(() => {
      if (isString(data)) {
        routeModalRef.current.open(data, props);
      }
      if (isArray(data)) {
        const index = isAR ? data.length - 1 : 0;
        modalRef.current.open(data, index);
      }
    });
  };

  const onScroll = () => {
  	const winHeight = window.innerHeight || document.documentElement.clientHeight
  	let newsImageContentDoms = document.querySelectorAll('.news-list-item-image-content')
  	let newsImageDoms = document.querySelectorAll('.news-list-item-image')
  	let newsTitleDoms = document.querySelectorAll('.news-list-item-title')
  	let newsDescDoms = document.querySelectorAll('.news-list-item-desc')
  	let btnDoms = document.querySelectorAll('.news-list-item .btn-content')
  	let contentDoms = document.querySelector('.page-content')

  	for(let i=0; i<newsImageContentDoms.length; i++) {
			if(newsImageContentDoms[i].getBoundingClientRect().top < winHeight) {
				newsImageContentDoms[i].setAttribute('class', 'news-list-item-image-content active')
				newsImageDoms[i].setAttribute('class', 'c-background-image news-list-item-image active')
			}
		}

		for(let i=0; i<newsTitleDoms.length; i++) {
			if(newsTitleDoms[i].getBoundingClientRect().top < winHeight) {
				newsTitleDoms[i].setAttribute('class', 'news-list-item-title active')
			}
		}

		for(let i=0; i<newsDescDoms.length; i++) {
			if(newsDescDoms[i].getBoundingClientRect().top < winHeight) {
				newsDescDoms[i].setAttribute('class', 'news-list-item-desc active')
				if(btnDoms[i]) {
					btnDoms[i].setAttribute('class', 'btn-content active')
				} 
			}
		}

		if(contentDoms?.getBoundingClientRect()?.top < winHeight) {
			if(!(showPage?.value) || !(Math.ceil(list.length/pageSizeValue) > 1) || !(buttonText?.value)) {
				contentDoms.setAttribute('class', 'page-content middle active')
			} else {
				contentDoms.setAttribute('class', 'page-content active')
			}
		}
  }

  const animateIn = () => {
  	setIsActive(true)
  }

  // 上一页
  const pagePrev = () => {
    gtag('event', 'Component_info', {
      'component_name': 'NewsList',
      'page_title': page?.name
    });
  	if (currentPage === 0) { return false }
		setCurrentPage(currentPage - 1)
		animateIn()
  }

 	// 下一页
  const pageNext = () => {
    gtag('event', 'Component_info', {
      'component_name': 'NewsList',
      'page_title': page?.name
    });
  	if (currentPage === Math.ceil(list.length / pageSizeValue) - 1) { return false }
		setCurrentPage(currentPage + 1)
		animateIn()
  }

  // 鼠标移动
  const mousemove = (e) => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    const eventY = e.clientY || (e.touches && e.touches[0]?.clientY) || 0
    let domHeight = rootEl.current?.getBoundingClientRect().height
    let domOffsetTop = rootEl.current?.getBoundingClientRect()?.top
    let top = 0
    if(eventY - 60 - domOffsetTop < 0) {
      top = 0
    } 
    else if(eventY - domOffsetTop > domHeight - 60) {
      top = domHeight - 120
    } 
    else {
      top = eventY - 60 - domOffsetTop
    }
    // dragEl.current.style.top = top  + 'px'
    // dragEl.current.style.left = eventX - 60 + 'px'
  }

  // 鼠标移出
  const mouseLeave = (e) => {
    setShowDrag(false)
  }

  const overButtonFn = () => {
    setOverButton(true)
  }

  const leaveButtonFn = () => {
    setOverButton(false)
  }

  // 鼠标移入
  const mouseOver = (e) => {
    setShowDrag(true)
  }

  const touchStart = (e) => {
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    setStartX(eventX)
  }
  const touchEnd = (e) => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    const endX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    if(endX - startX < -50) { //切换到下一个
      if(isAR) {
        if (currentPage === 0) { return false }
        setCurrentPage(currentPage - 1)
        animateIn()
      } else {
        if (currentPage === Math.ceil(list.length / pageSizeValue) - 1) { return false }
        setCurrentPage(currentPage + 1)
        animateIn()
      }
    } else if(endX - startX > 50) { //切换到上一个
      if(isAR) {
        if (currentPage === Math.ceil(list.length / pageSizeValue) - 1) { return false }
        setCurrentPage(currentPage + 1)
        animateIn()
      } else {
        if (currentPage === 0) { return false }
        setCurrentPage(currentPage - 1)
        animateIn()
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll)
    return () => {
			window.removeEventListener("scroll", onScroll)
		}
  }, [])

  const rootClasses = classNames("c-news-list", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootEl} onMouseMove={mousemove} onMouseDown={touchStart} onMouseUp={touchEnd} onMouseLeave={mouseLeave} onMouseOver={mouseOver}>
    	<div className="news-list-content">
    		{list.map((item, index) => (
          (index < (currentPage + 1) * pageSizeValue) && (index + 1 > currentPage * pageSizeValue) && <NewItem {...item} key={item.id} onClick={onSlideClick} isMobile={isMobile} index={index} pageSizeValue={pageSizeValue} isActive={isActive} onMouseOver={overButtonFn} onMouseLeave={leaveButtonFn} />
        ))}
			</div>
			{(buttonText?.value || (showPage?.value && list.length/pageSizeValue > 1)) && <div className={["page-content", (!(showPage?.value) || !(list.length/pageSizeValue > 1) || !(buttonText?.value)) ? 'middle' : ''].join(' ')} onMouseOver={overButtonFn} onMouseLeave={leaveButtonFn}>
				{showPage?.value && list.length/pageSizeValue > 1 && <div className={["next-and-prev", currentPage === 0 ? 'disablePrev' : '', currentPage === Math.ceil(list.length / pageSizeValue) - 1 ? 'disableNext' : '', !buttonText?.value ? 'rel' : ''].join(' ')}>
					<div className="page-prev" onClick={pagePrev}>
						<Icon name="ArrowBack" className="page__left" />
					</div>
					<div className="page-next" onClick={pageNext}>
		      	<Icon name="ArrowForward" className="page__right" />
		      </div>
				</div>}
				{buttonText?.value && <PrimaryButton {...{
        	buttonText: buttonText,
		      colorScheme: colorScheme,
		      iconName: iconName,
		      link: link
        }} />}
			</div>}
			<ImageCarouselModal ref={modalRef} />
      <RouteModal ref={routeModalRef} page={page}/>
      {/* drag */}
      {/* <div ref={dragEl} className={["drag-content", (showDrag && !overButton) ? 'show' : 'hidden'].join(' ')}>
        <RichText tag="div" className="drag" field={dragtext} />
      </div> */}
    </div>
  );
};

const NewItem = props => {
  const { fields, isMobile, index, pageSizeValue, isActive, onClick, onMouseOver, onMouseLeave } = props;
  const { image, pc_title, pc_desc, m_title, m_desc, link, modalLink, modalItems, colorScheme, iconName, buttonText } = fields;
  const btnProps = {
    colorScheme,
    iconName,
    buttonText,
    link
  };
  if (modalItems.length > 0) {
    Object.assign(btnProps, {
      callback() {
        onClick &&
          onClick(
            modalItems.map(x => ({
              image: x.fields.image.value,
              title: x.fields.title.value
            }))
          );
      }
    });
  }
  if (modalLink.value) {
    Object.assign(btnProps, {
      callback() {
        onClick && onClick(modalLink.value.replace(/^.*\/home/gi, ""));
      }
    });
  }
  const overItemButtonFn = () => {
    onMouseOver()
  }

  const leaveItemButtonFn = () => {
    onMouseLeave()
  }
  return (
    <div
			className={["news-list-item", (index > 2 && pageSizeValue > 3) ? 'active' : ''].join(' ')}
			key={index}
			>
			<div className={["news-list-item-image-content", isActive ? 'active' : ''].join(' ')}>
				<div className={["news-list-item-image", isActive ? 'active' : ''].join(' ')} style={{ backgroundImage: `url(${image.value.src})` }}  />
			</div>
			{!isMobile && pc_title?.value && <RichText tag="div" className={["news-list-item-title", isActive ? 'active' : ''].join(' ')} field={pc_title} />}
			{!isMobile && pc_desc?.value && <RichText tag="div" className={["news-list-item-desc", isActive ? 'active' : ''].join(' ')} field={pc_desc} />}
			{isMobile && m_title?.value && <RichText tag="div" className={["news-list-item-title", isActive ? 'active' : ''].join(' ')} field={m_title} />}
			{isMobile && m_desc?.value && <RichText tag="div" className={["news-list-item-desc", isActive ? 'active' : ''].join(' ')} field={m_desc} />}
			{buttonText?.value && <div className={["btn-content", isActive ? 'active' : ''].join(' ')} onMouseOver={overItemButtonFn} onMouseLeave={leaveItemButtonFn}>
				<PrimaryButton {...btnProps} />
			</div>}
	  </div>
  );
};

export default 	NewsList;